export default __webpack_public_path__ + "static/media/Level_three.8075b8a3.svg";